// extracted by mini-css-extract-plugin
module.exports = {"assignment_feed":"AssignmentFeed_assignment_feed__1D6Xo","noAssignmentOrQuiz":"AssignmentFeed_noAssignmentOrQuiz__3ceXX","loader":"AssignmentFeed_loader__2vSNJ"};